import { createIcon } from '@chakra-ui/react';

export const ArrowRightCircleIcon = createIcon({
  displayName: 'ArrowRightCircleIcon',
  viewBox: '0 0 32 32',
  path: (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.7094 10.7901C16.1014 10.4011 16.7346 10.4036 17.1236 10.7957L22.0849 15.7957C22.4717 16.1855 22.4717 16.8145 22.0849 17.2044L17.1236 22.2043C16.7346 22.5964 16.1014 22.5989 15.7094 22.2098C15.3174 21.8208 15.3149 21.1877 15.7039 20.7956L18.974 17.5L10.625 17.5C10.0727 17.5 9.625 17.0523 9.625 16.5C9.625 15.9477 10.0727 15.5 10.625 15.5L18.974 15.5L15.7039 12.2044C15.3149 11.8123 15.3174 11.1792 15.7094 10.7901Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 16.5C3 9.32271 8.82272 3.5 16 3.5C23.1773 3.5 29 9.32272 29 16.5C29 23.6773 23.1773 29.5 16 29.5C8.82271 29.5 3 23.6773 3 16.5ZM16 5.5C9.92728 5.5 5 10.4273 5 16.5C5 22.5727 9.92728 27.5 16 27.5C22.0727 27.5 27 22.5727 27 16.5C27 10.4273 22.0727 5.5 16 5.5Z'
        fill='currentColor'
      />
    </>
  ),
});
